var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('page-meta');
import { breakpoints, theme } from '@shapeable/theme';
import { CellLabel } from '../elements/cell-label';
import { formatDateString } from '../../utils/format-date-string';
import { useEntity } from '../../hooks/use-entity';
import { useLang } from '../../hooks/use-lang';
import { filter, get, sortBy, uniqBy } from 'lodash';
import { CSS_DOTS, PLATFORM_DATE_FORMAT } from '../../constants';
import { PersonImage } from './person-image';
import { useMonthNamesShort } from '../../hooks/use-month-names-short';
export var PageMetaDefaultProps = {
  label: 'Written By:',
  photoSize: 50,
  labelWithoutPerson: 'Published:',
  showAllPositions: true,
  showEdited: true
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(15))
});
var LabelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-weight: 300;\n    font-size: 1em;\n    color: ", ";\n    margin-bottom: ", ";\n  "], ["\n    font-weight: 300;\n    font-size: 1em;\n    color: ", ";\n    margin-bottom: ", ";\n  "])), theme.COLOR('text-subtle'), theme.UNIT(1))
});
var NameStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0 0 ", " 0;\n    font-weight: 500;\n    font-size: ", "em;\n    line-height: 1.35em;\n  "], ["\n    margin: 0 0 ", " 0;\n    font-weight: 500;\n    font-size: ", "em;\n    line-height: 1.35em;\n  "])), theme.UNIT(1), 18 / 15)
});
var PositionsStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: 0 0 ", " 0;\n    font-size: ", "em;\n    font-weight: 300;\n    line-height: 1.35em;\n    list-style: none;\n    padding: 0;\n  "], ["\n    margin: 0 0 ", " 0;\n    font-size: ", "em;\n    font-weight: 300;\n    line-height: 1.35em;\n    list-style: none;\n    padding: 0;\n  "])), theme.UNIT(1), 16 / 15)
});
var PositionStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin: 0 0 ", ";\n  "], ["\n    margin: 0 0 ", ";\n  "])), theme.UNIT(1))
});
var DateStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: ", "em;\n    ", ";\n    padding-top: ", ";\n    font-weight: 300;\n\n  "], ["\n    font-size: ", "em;\n    ", ";\n    padding-top: ", ";\n    font-weight: 300;\n\n  "])), 16 / 15, CSS_DOTS, theme.UNIT(3))
});
var PersonStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    display: flex;\n  "], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    display: flex;\n  "])), theme.UNIT(2), theme.UNIT(3))
});
var DetailsStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var PhotoStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme.UNIT(2))
});
var EditedStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    font-size: 0.9em;\n    font-weight: 300;\n    color: ", ";\n    display: inline-block;\n    padding-left: ", "; \n  "], ["\n    font-size: 0.9em;\n    font-weight: 300;\n    color: ", ";\n    display: inline-block;\n    padding-left: ", "; \n  "])), theme.COLOR('text-mid'), theme.UNIT(2))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled(CellLabel)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Person: styled.div.attrs(cls.attr('person'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), PersonStyles),
  Details: styled.div.attrs(cls.attr('details'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), DetailsStyles),
  Name: styled.h2.attrs(cls.attr('name'))(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Positions: styled.ul.attrs(cls.attr('positions'))(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), PositionsStyles),
  Position: styled.li.attrs(cls.attr('position'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), PositionStyles),
  Photo: styled(PersonImage)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), PhotoStyles),
  Date: styled.div.attrs(cls.attr('date'))(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), DateStyles),
  Edited: styled.span.attrs(cls.attr('edited'))(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), EditedStyles)
};
export var PageMeta = function PageMeta(props) {
  var className = props.className,
      children = props.children,
      label = props.label,
      labelWithoutPerson = props.labelWithoutPerson,
      photoSize = props.photoSize,
      showEdited = props.showEdited;
  var entity = useEntity(props.entity);
  var published = entity.published,
      edited = entity.edited,
      _a = entity.authors,
      authors = _a === void 0 ? [] : _a,
      _b = entity.people,
      people = _b === void 0 ? [] : _b;
  var peopleToShow = uniqBy(__spreadArray(__spreadArray([], __read(authors), false), __read(people), false), 'slug');
  var hasPeople = !!peopleToShow.length;
  var monthNamesShort = useMonthNamesShort();
  var t = useLang();
  var publishedDate = published && formatDateString(published, t('Do MMM YYYY'), PLATFORM_DATE_FORMAT, {
    monthNamesShort: monthNamesShort
  });
  var editedDate = edited && formatDateString(edited, t('Do MMM YYYY'), PLATFORM_DATE_FORMAT, {
    monthNamesShort: monthNamesShort
  });
  var editedShortDate = edited && formatDateString(edited, t('Do MMM'), PLATFORM_DATE_FORMAT, {
    monthNamesShort: monthNamesShort
  });
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Label, null, t(hasPeople ? label : labelWithoutPerson)), hasPeople && peopleToShow.map(function (person) {
    var org = person && person.organisation;
    var position = person && person.position;
    var positions = sortBy(person && person.positions || [], function (position) {
      return position.primary ? 0 : 1;
    });
    var showAllPositions = props.showAllPositions && !!positions.length;
    var positionsToShow = showAllPositions ? positions.map(function (pos) {
      return filter([get(pos, 'positions[0].name', pos.position), pos.organisation && pos.organisation.name]).join(", ");
    }) : [filter([position, org && org.name]).join(", ")];

    if (!published && !person) {
      return null;
    }

    return React.createElement(My.Person, {
      key: "meta-people-" + person.slug
    }, React.createElement(My.Photo, {
      size: photoSize,
      entity: person
    }), React.createElement(My.Details, null, React.createElement(My.Name, null, person.name), !!positionsToShow.length && React.createElement(My.Positions, null, positionsToShow.map(function (pos) {
      return React.createElement(My.Position, {
        key: pos
      }, pos);
    }))));
  }), published && React.createElement(My.Date, null, publishedDate, showEdited && editedDate && editedDate !== publishedDate && React.createElement(My.Edited, null, "(", t('Edited: '), editedShortDate, ")")), children);
};
PageMeta.defaultProps = PageMetaDefaultProps;
PageMeta.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;